import { notification } from "antd";

const placementMap = {
  "top-left": "topLeft",
  "top-right": "topRight",
  "top-center": "topRight",
  "bottom-left": "bottomLeft",
  "bottom-right": "bottomRight",
  "bottom-center": "bottomRight",
};

const typeMap = {
  danger: "error",
  default: "open",
  success: "success",
  warning: "warning",
  info: "info",
};

export const store = {
  addNotification({
    title,
    message,
    type,
    container,
    dismiss,
  }) {
    const method = typeMap[type] || "open";
    const duration = dismiss?.duration ? dismiss.duration / 1000 : 0;

    notification[method]({
      message: title,
      description: message,
      placement: placementMap[container] || "topRight",
      duration,
    });
  },
};

export const ReactNotifications = () => null;
